import { render } from "./MultipleSelect.vue?vue&type=template&id=4fa5744a&scoped=true"
import script from "./MultipleSelect.vue?vue&type=script&lang=js"
export * from "./MultipleSelect.vue?vue&type=script&lang=js"

import "./MultipleSelect.vue?vue&type=style&index=0&id=4fa5744a&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa5744a"]])

export default __exports__